import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, matchPath, useLocation } from "react-router-dom";
import Navigation from "./Layout/Nav/Nav";
import Footer from "./Layout/Footer/Footer";
import Main from "./Pages/Home/Home";
import Contact from "./Pages/Contact";
import BlogList from "./Pages/Blog/BlogList";
import BlogDetail from "./Pages/Blog/BlogDetail";
import Privacy from "./Pages/Privacy/Privacy";
import Download from "./Pages/Download/Download";
import GlobalDownloadCTA from "./Components/GlobalDownloadCTA/GlobalDownloadCTA";
import "./css/styles.css";
import "./locales/i18n";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react";
import { Buffer } from "buffer";
import { pageview } from "./gtag";
import { useTranslation } from "react-i18next";
window.Buffer = Buffer;

function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);

  return null;
}

function AppRoutes() {
  const location = useLocation();
  const isLegalPage = Boolean(matchPath(location.pathname, {
    path: "/:lang/privacy/:slug",
    exact: true,
  }));
  const isHomePage = location.pathname === "/";

  if (isLegalPage) {
    return (
      <Switch>
        <Route exact path="/:lang/privacy/:slug" component={Privacy} />
      </Switch>
    );
  }

  return (
    <div className={`app-container${isHomePage ? " home-app-container" : ""}`} style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navigation />
      <div className="content-wrap" style={{ flex: "1 0 auto", display: "flex", flexDirection: "column" }}>
        <Switch>
          <Route path="/" exact component={Main} />
          <Route path="/Contact" exact component={Contact} />
          <Route exact path="/blog" component={BlogList} />
          <Route path="/blog/:slug" component={BlogDetail} />
          <Route path="/download" exact component={Download} />
        </Switch>
      </div>
      <Footer />
    </div>
  );
}

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <Router>
      <RouteTracker />
      <AppRoutes />
      <GlobalDownloadCTA />
      <SpeedInsights />
      <Analytics />
    </Router>
  );
}

export default App;
